import type {FollowUpPromptsV2} from '@/views/Chat/types'

import style from './FollowUpTopicsV2.module.scss'

const FollowUpTopicV2 = memo<{
  topic: FollowUpPromptsV2[number]
  submitMessage: (msg: string) => void
}>(function FollowUpTopic({topic, submitMessage}) {
  if (topic !== '')
    return (
      <div role='listitem'>
        <button
          onClick={() => {
            submitMessage(topic)
          }}
          className={style.FollowUpTopic}
        >
          {topic}
        </button>
      </div>
    )

  return null
})

export default memo<{
  topics: FollowUpPromptsV2
  submitMessage: (msg: string) => void
}>(function FollowUpTopicsV2({topics, submitMessage}) {
  return (
    <div>
      <div className={style.FollowUpTopics} role='list' aria-label='possible follow up topics'>
        {topics.slice(0, 6).map((topic, i) => (
          <FollowUpTopicV2 topic={topic} key={i} submitMessage={submitMessage} />
        ))}
      </div>
    </div>
  )
})
